import { render, staticRenderFns } from "./CompletionResults.vue?vue&type=template&id=2036a8cf&scoped=true&"
import script from "./CompletionResults.vue?vue&type=script&lang=js&"
export * from "./CompletionResults.vue?vue&type=script&lang=js&"
import style0 from "./CompletionResults.vue?vue&type=style&index=0&id=2036a8cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036a8cf",
  null
  
)

export default component.exports